module.exports = __webpack_public_path__ + "static/media/testfile_shadowGenerator.71077531.zip";